import React from 'react'
import { Feedback } from '../modules/companies'

export const NpsPage = () => {
    return (
        <Feedback />
    );
}
